import { AppliancesIcon } from 'components/ProductSidebar/ProductGroupNav/ProductGroupNavSVGs';
import { ProductGroup } from 'rangeConfig/@types';
import selectedMenu from './selectedMenu';
import mainMenu from './mainMenu';
import { ProductType } from '@inter-ikea-storageone/range';

const appliances = (): ProductGroup => {
  return {
    id: 'appliances-knoxhult',
    productTypes: [
      ProductType.APPLIANCE_INTEGRATED_HOB,
      ProductType.APPLIANCE_INTEGRATED_OVEN,
      ProductType.APPLIANCE_FRIDGE_FREEZER,
      ProductType.APPLIANCE_FREE_HANGING_EXTRACTOR_HOOD,
      ProductType.APPLIANCE_CABINET_EXTRACTOR_HOOD
    ],
    icon: AppliancesIcon,
    mainMenu,
    selectedMenu
  };
};

export default appliances;
